import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { formatNisAmount, mapSpendPeriodsToChartData } from '../../utils/labData';

/**
 * Monthly spend bar chart from by-period API (`period_start` + `total_nis`).
 */
const SpendOverTimeChart = ({ periods = [], granularity = 'month' }) => {
  const chartData = mapSpendPeriodsToChartData(periods, granularity);

  return (
    <Card variant="outlined" className="lab-data-chart-card">
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Spend over time
        </Typography>
        {chartData.length === 0 ? (
          <Typography color="text.secondary">No spend data for this period.</Typography>
        ) : (
          <ResponsiveContainer width="100%" height={320}>
            <BarChart
              data={chartData}
              margin={{ top: 8, right: 16, left: 8, bottom: 8 }}
            >
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis
                dataKey="label"
                interval={0}
                tick={{ fontSize: 12 }}
                height={48}
              />
              <YAxis tick={{ fontSize: 12 }} />
              <Tooltip
                formatter={value => formatNisAmount(value)}
                labelStyle={{ fontWeight: 600 }}
              />
              <Bar dataKey="amount" fill="#1976d2" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
};

export default SpendOverTimeChart;
